import { YouTubeTracker } from "@world-vision/wv360-core-library";
import React, { useEffect } from "react";

export const useVideoTracker = () => {
  const [loaded, setLoaded] = React.useState(false);
  const { init, load } = YouTubeTracker();
  useEffect(() => {
    if (!loaded) {
      console.log("First YouTubeTracker loaded");
      init();
      setLoaded(true);
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector("iframe[src*='youtube.com']")) {
        load();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
  return null;
};

export default useVideoTracker;
